import React, { useState, FC, ReactNode, ReactElement, CSSProperties } from 'react';

import {
  SelectionOnCustomer
} from '../queries/GetCustomerHomeInformation.graphql';
import SessionManager from 'src/util/sessionManager';

import { Text } from '@amount/frontend-components';

interface IRefinanceApplyProps {
  refiInformation: SelectionOnCustomer['refiInformation'];
}

interface HoverOverBoxProps {
  children: ReactElement;
  content: ReactNode;
}

const HoverOverBox: FC<HoverOverBoxProps> = ({ children, content }) => {
  const [isVisible, setIsVisible] = useState(false);

  const hoverOverStyle: CSSProperties = {
    position: 'absolute',
    top: '100%',
    left: '50%',
    transform: 'translateX(-50%)',
    marginTop: '8px',
    padding: '8px 12px',
    background: 'white',
    color: 'black',
    border: '1px solid #ccc',
    minWidth: '350px',
    maxWidth: '500px',
    whiteSpace: 'normal',
    textAlign: 'left',
    borderRadius: '4px',
    fontSize: '14px',
    zIndex: 10,
    opacity: isVisible ? 1 : 0,
    visibility: isVisible ? 'visible' : 'hidden',
    transition: 'opacity 0.2s, visibility 0.2s',
  };

  const hoverOverContainerStyle: CSSProperties = {
    position: 'relative',
    display: 'inline-block',
  };

  return (
    <div
      style={hoverOverContainerStyle}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      <div style={hoverOverStyle}>
        {content}
      </div>
    </div>
  );
};


const RefinanceApply: React.FunctionComponent<IRefinanceApplyProps> = ({
  refiInformation
}) => {

  if (!refiInformation?.canApplyForRefi) {
    return null;
  }

  var hoverText = "If you are looking for additional funds, you can apply for a new loan and you will\
    be presented with new rates and terms. The proceeds of the new loan will be used to pay off your existing\
    loan. Additional funds will be deposited to your bank account and a new loan will be created."

  return (
    <>
      <Text
        align='right'
      >
        <b>
          <HoverOverBox content={hoverText}>
          <a href={SessionManager.urlRouter.apiBaseUrl+refiInformation.applyUrl}>
            Need more money? Click here.
          </a>
          </HoverOverBox>
        </b>
      </Text>
    </>
  );
};

export default RefinanceApply;
